export default __webpack_public_path__ + "static/mcs1-f195603ba708317813bd787fe5cf3f61.webp";